import { getPokusValueFromLS } from './pages/cabsPokus';
import { CABS_LANDING_SNACKBAR } from './utils/pokusContstants';

export const showSnackBar = () => {
  return getPokusValueFromLS(CABS_LANDING_SNACKBAR, false);
};
